<template>
    <section>
        <el-tabs v-model="activeTab"
                 v-if="(sendEmail || sendSms) && _.size(toEmails)">
            <el-tab-pane :label="_.get(email, 'email', email)" :name="key.toString()" class="fin-space-y-4"
                         v-for="(email, key) in toEmails"
                         :key="key">
                <email-editor
                    :to-email="email"
                    :is-api="isApi"
                    :show-sms="true"
                    :show-email="true"/>
            </el-tab-pane>
        </el-tabs>
        <el-tabs v-model="activeTab"
                 v-if="(sendEmail || sendSms) && _.size(bccsEmails) && _.isEmpty(toEmails)">
            <el-tab-pane :label="_.get(email, 'email', email)" :name="key.toString()" class="fin-space-y-4"
                         v-for="(email, key) in bccsEmails"
                         :key="key">
                <email-editor
                    :to-email="email"
                    :is-api="isApi"
                    :show-sms="true"
                    :show-email="true"/>
            </el-tab-pane>
        </el-tabs>
    </section>
</template>

<script>
import {mapGetters} from "vuex";
import EmailEditor from "./EmailEditor";

export default {
    name: 'EmailTemplates',
    components: {
        EmailEditor
    },
    props: {
        isApi: {
            required: true,
        }
    },
    data() {
        return {
            activeTab: '0'
        }
    },
    computed: {
        ...mapGetters({
            sendEmail: "ticketEmail/getSendEmail",
            sendSms: "ticketEmail/getSendSms",
            emailTemplate: "ticketEmail/getEmailTemplate",
            smsTemplate: "ticketEmail/getSmsTemplate",
            toEmails: "ticketEmail/getToEmails",
            bccsEmails: "ticketEmail/getBCCsEmails",
        }),
    },
    watch: {
        'toEmails': {
            handler(val) {
                console.log('toEmails ', val)
            },
            immediate: true
        }
    },
    mounted() {
    }
}
</script>
